import { authClient } from "@/shared/lib/axios";
import {
	type UpdateWorkflowEnvRequest,
	UpdateWorkflowEnvRequestSchema,
	type WorkflowEnvResponse,
	WorkflowEnvResponseSchema,
} from "./workflow-env.types";

export const workflowEnvApi = {
	getEnv: async (workflowId: string): Promise<WorkflowEnvResponse> => {
		const { data } = await authClient.get(`/workflows/${workflowId}/env`);
		return WorkflowEnvResponseSchema.parse(data);
	},

	updateEnv: async (
		workflowId: string,
		request: UpdateWorkflowEnvRequest,
	): Promise<WorkflowEnvResponse> => {
		const payload = UpdateWorkflowEnvRequestSchema.parse(request);
		const { data } = await authClient.put(`/workflows/${workflowId}/env`, payload);
		return WorkflowEnvResponseSchema.parse(data);
	},
};
